import { SubmissionState } from "@idw-types/state";
import { SubmissionActions, SubmissionActionTypes } from "../actions/submission-actions";
import { RootActions, RootActionTypes } from "../actions/root-actions";

export const initialSubmissionState: SubmissionState = {
    submitting: false,
    processing: false,
    complete: false,
    failed: false
};

export const submissionReducer = (
    state: SubmissionState = initialSubmissionState,
    action: SubmissionActions | RootActions
) => {
	switch (action.type) {
		case SubmissionActionTypes.SET_SUBMISSION_SUBMITTING:
			return {
				submitting: action.payload.isSubmitting,
                processing: false,
                complete: false,
                failed: false
			};
        case SubmissionActionTypes.SET_SUBMISSION_PROCESSING:
            return {
                submitting: false,
                processing: action.payload.isProcessing,
                complete: false,
                failed: false
            };
        case SubmissionActionTypes.SET_SUBMISSION_COMPLETE:
            return {
                submitting: false,
                processing: false,
                complete: action.payload.isComplete,
                failed: false
            };
        case SubmissionActionTypes.SET_SUBMISSION_FAILED:
            return {
                submitting: false,
                processing: false,
                complete: false,
                failed: true
            };
        case SubmissionActionTypes.RESET_SUBMISSION_SUBMIT_STATUS:
            return initialSubmissionState;
        case RootActionTypes.RESET_STATE:
            return { ...initialSubmissionState };
		default:
			return state;
	}
};